import {
  Component,
  Input,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { SelectItem } from "primeng/api";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { SelectedChipsComponent } from "../../chip/selected-chips.component";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { quoteSource } from "../../../quote/quote-source.const";

export type QuoteSourceValue = string | null;

@Component({
  selector: "app-quote-source-multiselect",
  templateUrl: "./quote-source-multiselect.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Checkbox, FormsModule, SelectedChipsComponent],
})
export class QuoteSourceMultiselectComponent {
  readonly appendTo = input("");
  readonly disabled = input(false);
  @Input() selectedSources: QuoteSourceValue[] = [];
  readonly selectionChange = output<QuoteSourceValue[]>();

  public sourceList: SelectItem[] = [
    { label: "Quotiss User", value: null },
    { label: "Online", value: quoteSource.online },
    { label: "Internal Email", value: quoteSource.internalEmail },
    { label: "External Email", value: quoteSource.externalEmail },
  ];

  public onSourceChange() {
    this.selectionChange.emit(this.selectedSources);
  }

  public readonly chipLabel = (source: QuoteSourceValue): string =>
    this.getSourceLabel(source);

  public removeSource(source: QuoteSourceValue) {
    this.selectedSources = this.selectedSources.filter(
      (value) => value !== source,
    );
    this.onSourceChange();
  }

  public isSelected(source: QuoteSourceValue): boolean {
    return this.selectedSources.includes(source);
  }

  public getSourceLabel(source: QuoteSourceValue): string {
    return this.sourceList.find((item) => item.value === source)?.label ?? "";
  }
}
